import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../ui/Button/Button';
import { PageTitle } from '../../ui/PageTitle/PageTitle';
import { TranslationKey } from '../../i18n/translationKeys';
import type { ScreenRefusedProps } from './types';

/**
 * Shown when the user confirmed "Je préfère refuser" instead of completing consent — no sync ever
 * ran. Scoped explicitly to relance: the rest of Acomba GO keeps working normally.
 */
export const ScreenRefused: React.FC<ScreenRefusedProps> = ({ onContinue }) => {
    const { t } = useTranslation();

    return (
        <div data-testid="onboarding-screen-refused" className="flex flex-col items-center justify-center min-h-screen gap-xl px-l text-center">
            <PageTitle data-testid="onboarding-refused-title">{t(TranslationKey.Onboarding.Refused.Title)}</PageTitle>
            <p className="text-body text-content-secondary max-w-md">{t(TranslationKey.Onboarding.Refused.Message)}</p>
            <Button data-testid="onboarding-refused-continue-btn" onClick={onContinue}>
                {t(TranslationKey.Onboarding.Refused.Continue)}
            </Button>
        </div>
    );
};
